export default "__VITE_ASSET__80b99cc0__"